import { Text, View } from "@react-pdf/renderer";
import PrintHeading from "../../common/Heading";

export default function TermsAndConditionsBlock({
    terms,
}: {
    terms: string[];
}) {
    return (
        <View>
            <PrintHeading
                englishTitle="Terms & Conditions"
                arabicTitle="اﻟﺸﺮوط واﻷﺣﻜﺎم"
            />
            {terms && terms.length > 0 ? (
                terms.map((term, index) => (
                    <Text
                        key={index}
                        style={{
                            margin: "2px 0px",
                        }}
                    >
                        {index + 1}. {term}
                    </Text>
                ))
            ) : (
                <Text style={{ fontSize: 6, margin: "2px 0px" }}>
                    No terms and conditions specified
                </Text>
            )}
        </View>
    );
}
